export function convertTo24Hour(time12h: string) {
  let [time, modifier] = time12h.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  } else if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
}

export function convertTo12Hour(time24h: string): string {
  const [hours, minutes] = time24h.split(":").map(Number);

  // Create a Date object with today's date but with the given time
  const date = new Date();
  date.setHours(hours, minutes, 0, 0); // Set hour, minute, second, millisecond

  // Use Intl.DateTimeFormat to format it to 12-hour time
  return new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}

export function getFullDayName(shortName: string) {
  const days = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };

  return days[shortName] || "Invalid day";
}
